/*
 * Operations to arrange mark up and highlight of a openlayers polygon
 * on the map.
 */

/* OpenLayers imports */
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import OlFill from 'ol/style/Fill';
import Polygon from 'ol/geom/Polygon';
import Feature from 'ol/Feature';
import { getArrayDepth } from '../../services/utilities';

/**
 * Creates a ol polygon object with given coordinates
 * @param polygonCoordinates
 */
function getPolygon(polygonCoordinates) {
    // Array needs to be 3 deep, add a level if it's 2 deep
    const arrayDepth = getArrayDepth(polygonCoordinates);
    if (arrayDepth === 2) {
        polygonCoordinates = [polygonCoordinates];
    }
    const polygon = new Polygon(polygonCoordinates, 'XY');
    polygon.transform('EPSG:4326', 'EPSG:28992');
    return polygon;
}


/**
     * Returns ol feature with set styled
     * @param {any} polygonCoordinates
     */
export function getFeature(polygonCoordinates) {
    // Get polygon for given coordinates
    const polygon = getPolygon(polygonCoordinates);
    // Create new ol feature
    return new Feature({ geometry: polygon });
}

/**
     * Set the style property of the feature
     * @param {any} polygonCoordinates
     */
export function getStyledFeature(polygonCoordinates) {
    const feature = getFeature(polygonCoordinates);
    // Set style properties
    feature.setStyle(new OlStyle({
        stroke: new OlStroke({
            color: 'rgb(255,0,0,1)',
            width: 2
        }),
        fill: new OlFill({ color: 'rgba(255, 0, 0, 0.2)' })
    }));
    return feature;
}

/**
     * Return a new vector layer
     * @param {any} polygonCoordinates
     */
export function getHighlightVector(polygonCoordinates) {
    const feature = getStyledFeature(polygonCoordinates);
    // Create new vector layer
    return new OlVectorLayer({ source: new OlVectorSource({ wrapX: false, features: [feature] }), zIndex: 999999 });
}
